import { Backdrop, CircularProgress, Typography } from '@mui/material'
import React, { useState } from 'react'

import UploadFile from './UploadFile/UploadFile'
import useStyles from './useStyles'
import InfoIcon from '@mui/icons-material/Info'
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined'
// import modeloPrueba from '../../../public/'

export const ImportCVS = () => {
  const classes = useStyles()
  const [loading, setLoading] = useState(false)

  const DescargarModelo = async () => {
    try {
      const response = await fetch(
        process.env.PUBLIC_URL + '/Modelo_de_documento.csv'
      )
      const data = await response.blob()
      const url = window.URL.createObjectURL(new Blob([data]))
      const enlace = document.createElement('a')
      enlace.href = url
      enlace.download = 'Modelo_de_documento.csv'
      enlace.click()
    } catch (error) {
      console.error('Error al descargar el archivo CSV:', error)
    }
  }

  return (
    <div className={classes.root}>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <div className={classes.boxtitle}>
        <Typography className={classes.title}>
          Habilitación de modulos mediante documento .CSV
        </Typography>
      </div>
      <div className={classes.boxSubTitle}>
        <InfoIcon
          style={{ fontSize: '2rem', color: '#00a78f', marginLeft: 10 }}
        />
        <Typography className={classes.subtitle}>
          En esta sección podrá habilitar los modulos de almacenamiento,
          mensajeria y tareas de una lista de organizaciones.<br></br> Si
          necesita visualizar un modelo de archivo haga click
          <button onClick={DescargarModelo} className={classes.linkButton}>
            aquí
          </button>
        </Typography>
      </div>
      <div className={classes.boxInput}>
        <Typography className={classes.titleInput}>
          Ingrese un documento de tipo .csv
        </Typography>

        <UploadFile setLoading={setLoading} />
      </div>
      <div className={classes.boxSubTitleAlert}>
        <ErrorOutlineOutlinedIcon
          style={{ marginLeft: 10, color: '#00a78f', fontSize: '1.5rem' }}
        />
        <Typography className={classes.subtitle}>
          Formato de fecha permitida: AAAA-MM-DD <i>Ej: 2023-01-30</i>
        </Typography>
      </div>
    </div>
  )
}
